import getLang from 'I18n/utils/getLang';
import CoreHSPageViewTracker from 'marketplace-ui-common/tracking/components/HSPageViewTracker';
import { getRootUrl } from 'marketplace-ui-common/utils/DetailsPageUrls';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
export function HSPageViewTracker({
  addLang = false,
  overrideTrack = false,
  pathname
}) {
  const {
    appContext
  } = useDetailsPageContext();
  const urlRoot = getRootUrl(appContext);
  const fullPathname = addLang ? `${urlRoot}${pathname}?user-language=${getLang()}` : `${urlRoot}${pathname}`;
  return CoreHSPageViewTracker({
    overrideTrack,
    pathname: fullPathname
  });
}